import React from "react";
import { Tooltip } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";

import { ExtendedPermission } from "fond/types";
import { isNew } from "fond/utils/permissions";
import { AccountTypeChip } from "fond/widgets/AccountSwitch";

const TypeCellRenderer: React.FC<ICellRendererParams<ExtendedPermission>> = ({ data: permission }) => {
  if (!permission || permission.IdentityType === "account") return null;

  const chip = <AccountTypeChip external={!!permission.External} role={permission.AccountRole} />;
  if (permission.External && !isNew(permission)) {
    return <Tooltip title="This user is not part of this workspace and cannot be granted permissions higher than collaborator">{chip}</Tooltip>;
  }
  return chip;
};

export default TypeCellRenderer;
